import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { store } from 'store/index';
import API from "api.js";
import { setToken, setUser, setLogo, setSub, setLoader } from 'action/index.js';


const mapStateToProps = (state) => {
	return {
		token: state.token
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setToken: (tok) => dispatch(setToken(tok)),
		setUser: (user) => dispatch(setUser(user)),
		setSub: (sub) => dispatch(setSub(sub)),
		setLogo: (sub) => dispatch(setLogo(sub))
	};
};

const CheckPost = (props) => {
	const location = useLocation();
	const navigate = useNavigate();

	console.log("inside check post");
	

	useEffect(() => {
		const query = new URLSearchParams(location.search);
		const cust = query.get('cust');

		if (!cust) {
			console.error('No cust parameter found');
			return;
		}

		console.log('Calling API with cust:', cust);
		store.dispatch(setLoader(true));

		API({
			method: 'GET',
			url: `/loginDataWithToken?cust=${cust}`,
		}).then((res) => {
			props.setToken(res.data.access_token);
			props.setUser(res.data.user);
			props.setLogo(res.data.image);
			
			let sub = (res.data.user.active_subscription.length === 0) ? false : true;
			props.setSub(sub);

			store.dispatch(setLoader(false));
			navigate('/admin/dashboard');
		}).catch(err => {
			console.error('API Error:', err);
			store.dispatch(setLoader(false));
			alert("Unable to process your request. Please try again from PTE academic dashboard.");
		});
	}, [location.search, navigate, props]);

	return "";
}
export default connect(mapStateToProps, mapDispatchToProps)(CheckPost);